import { ImageLibraryQueryKey } from 'js/types';

/**
 * Produces a stable, deterministic JSON string for use as a Redux cache key.
 * Source array is sorted so that order doesn't affect key equality.
 */
export const makeCacheKey = (queryKey: ImageLibraryQueryKey, offset: number): string =>
  JSON.stringify({ queryKey: { ...queryKey, source: [...queryKey.source].sort() }, offset });
